import React from "react";
import * as animationData from "./Registration_Lottie.json";
import "./Registration_Lottie.css";
import Lottie from "react-lottie";

export const Registration_Lottie = () => {
  const defaultOptions = {
    loop: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <section className="main">
      <div className="success_div">
        <Lottie className="me-auto lottie" options={defaultOptions} />
      </div>
    </section>
  );
};
